// The amount or content cards shown by default when the component
// is first rendered and before see more button is clicked
export const DEFAULT_ITEMS_TO_SHOW = 3;

// The maximum amount of content cards to show after see more button is clicked
export const MAX_ITEMS_TO_SHOW = 8;
